import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';

import { CourseAdminCard } from '@/components/shared/CourseAdminCard';
import {
  CardDragglableProps,
  CardStaticProps,
} from '@/components/shared/CourseAdminCard/types';
import { Toggle } from '@/components/ui/daisy';
import PedWorkspaceGuard from '@/components/shared/PedWorkspaceGuard';
import { usePedWorkspaceStatus } from '@/data/context/PedWorkspaceContext';

type ExamAreaCardProps = {
  name: string;
  isAttached?: boolean;
  onToggle: () => void;
  isPending?: boolean;
  ordinal?: number;
  className?: string;
} & (CardStaticProps | CardDragglableProps);

export default function ExamAreaCard({
  name,
  isAttached,
  onToggle,
  isPending,
  ordinal,
  ...cardProps
}: ExamAreaCardProps) {
  const { isLimitedEdition } = usePedWorkspaceStatus();
  const { t } = useTranslation('translation', {
    keyPrefix: 'courseLineForm.examWorkspace.settings',
  });

  return (
    <CourseAdminCard {...cardProps}>
      <CourseAdminCard.Header className={twMerge(!isAttached && 'opacity-60')}>
        <CourseAdminCard.Leading>
          <CourseAdminCard.Order value={ordinal} />
          <CourseAdminCard.Title className="font-medium">
            {name}
          </CourseAdminCard.Title>
        </CourseAdminCard.Leading>
        <CourseAdminCard.Actions className="gap-2">
          <span className="text-sm text-base-content">{t('showLabel')}</span>
          <PedWorkspaceGuard placement="left">
            <Toggle
              color="primary"
              checked={!!isAttached}
              onChange={() => onToggle()}
              disabled={isPending || isLimitedEdition}
            />
          </PedWorkspaceGuard>
        </CourseAdminCard.Actions>
      </CourseAdminCard.Header>
    </CourseAdminCard>
  );
}
